import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Text from "components/atoms/text/Text";

import PropTypes from "prop-types";

const Container = styled.div`
    padding: 8px;
    width: fit-content;
    min-width: 200px;
    background-color: var(--color-White);
    border: solid 1px #d6e8f1;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const MenuList = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    gap: 8px;
    width: 100%;
`;

const MenuItem = styled.div``;

const MenuItemButton = styled.button`
    display: flex;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 32px;
    background-color: var(--color-White);
    border: none;
    border-radius: 4px;
    transition: background-color 80ms ease-in, color 80ms ease-in;

    &:hover {
        background-color: var(--color-ButtonHover4);
        color: var(--color-White);
    }
`;

const MenuItemText = styled(Text)`
    margin: 0 0 0 12px;
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--color-Black);
`;

const MenuIcon = styled(Icon)``;

function PageHeaderMenu({ logoutClick, isStaff = false, setShowAdminChangeUserModal }) {
    const navigate = useNavigate();

    const menuItems = [
        {
            id: "account",
            label: "계정정보",
            iconName: "user",
            onClick: () => navigate("/account"),
            requiresStaff: false,
        },
        {
            id: "settings",
            label: "환경설정",
            iconName: "setting",
            onClick: () => navigate("/settings"),
            requiresStaff: false,
        },
        { id: "logout", label: "로그아웃", iconName: "logout", onClick: logoutClick, requiresStaff: false },
        {
            id: "changeUser",
            label: "(관리자) 계정 전환",
            iconName: "user",
            onClick: () => setShowAdminChangeUserModal(true),
            requiresStaff: true,
        },
    ];

    return (
        <Container>
            <MenuList>
                {menuItems.map((item) => {
                    if (item.requiresStaff && !isStaff) {
                        return null;
                    }

                    return (
                        <MenuItem key={item.id}>
                            <MenuItemButton onClick={item.onClick}>
                                <MenuIcon name={item.iconName} size={"12"} />
                                <MenuItemText>{item.label}</MenuItemText>
                            </MenuItemButton>
                        </MenuItem>
                    );
                })}
            </MenuList>
        </Container>
    );
}

PageHeaderMenu.propTypes = {
    logoutClick: PropTypes.func.isRequired,
    isStaff: PropTypes.bool.isRequired,
    setShowAdminChangeUserModal: PropTypes.func.isRequired,
};

export default PageHeaderMenu;
